<template>
  <div>

    <Row class="search-con">
      <Col>
        <Button @click="backHistory" class="search-btn">返回</Button>
      </Col>
    </Row>
    <Card>
      <tables
        editable
        :columns="columns"
        v-model="tableData"
        :loading="tableLoading"
      />
      <Row class="page-con">
        <div class="page-bottom">
          <Page
            :current="page"
            :total="total"
            :page-size="pageSize"
            show-sizer
            show-elevator
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </Row>
    </Card>
  </div>
</template>

<script>
import Tables from "_c/tables/table-only.vue";

import { listCommentMessage} from "@/api/data";
export default {
  name: "finance",
  components: {
    Tables
  },
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 10,
      letterDetailFlag: false,
      tableLoading: true,
      allMoney: 0.0,
      classify_id:'',
      startTime: "",
      endTime: "",
      details:[],
      comment_id:'',
      columns: [
        {type: 'index', title: '序号',width: 100, align: "center"},
        { title: "客户名称" , key: "author", editable: true },
        { title: "回复内容" , key: "content", editable: true },
        { title: "时间" , key: "create_time", editable: true }
      ],
      tableData: [],
    };
  },
  methods: {
    backHistory() {
      this.$router.go(-1);
    },
    cancel() {},
    changePage(page) {
      this.page = page;
      this.handleSearch();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.handleSearch();
    },
    handleSearch() {
      this.setTableLoading(true);
      let params = {
        page: this.page,
        pageSize: this.pageSize,
        comment_id: this.comment_id,
        type:1
      };
      listCommentMessage(params).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.setTableLoading(false);
      });
    },
    setTableLoading(state) {
      this.tableLoading = state;
    },
  },
  mounted() {
    this.comment_id = this.$route.query.id;
    this.handleSearch();
  },
};
</script>
